import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SubscribePage from "./pages/SubscribePage";
import SuccessPage from "./pages/SuccessPage";
import { PrivacyPage, TermsPage, RefundPage, ContactPage } from "./pages/PolicyPages";

const App = () => (
  <Routes>
    <Route path="/" element={<SubscribePage />} />
    <Route path="/success" element={<SuccessPage />} />
    <Route path="/privacy" element={<PrivacyPage />} />
    <Route path="/terms" element={<TermsPage />} />
    <Route path="/refund" element={<RefundPage />} />
    <Route path="/contact" element={<ContactPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default App;
